import React, { useState, useEffect } from "react";
import { Button, Typography, Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { WELCOME_PAGE_ENDPOINT } from "../../routes/endpointConstants";
import CloseIcon from "@mui/icons-material/Close";
import { useSidebar } from "../../contexts/SidebarContext";

const GetStartBanner: React.FC = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const { isCollapsed } = useSidebar();

  useEffect(() => {
    const dismissed = localStorage.getItem("getStartBannerDismissed");
    setIsVisible(!dismissed);
  }, []);

  const handleClick = () => {
    navigate(WELCOME_PAGE_ENDPOINT);
  };

  const handleDismiss = () => {
    localStorage.setItem("getStartBannerDismissed", "true");
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: "52px",
        left: isCollapsed ? "60px" : "250px",
        transition: "left 0.3s ease",
        right: 0,
        backgroundColor: "#00C0E0",
        padding: "8px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins",
          color: "white",
          fontSize: "16px",
        }}
      >
        <span style={{ fontWeight: "bold" }}>
          New to WriteAhead? Start here
        </span>{" "}
        - What is WriteAhead? How does one use it? Click the button to find out!
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          onClick={handleClick}
          sx={{
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: "bold",
            backgroundColor: "white",
            color: "#00C0E0",
            px: 2,
            py: 0.5,
            borderRadius: "6px",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          Get Started
        </Button>
        <IconButton
          onClick={handleDismiss}
          sx={{
            color: "white",
            padding: "4px",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
          title="Dismiss"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default GetStartBanner;
